import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorQuoterSummaryItemWithImage from "./BuilderEstimatorQuoterSummaryItemWithImage.vue";
  import BuilderEstimatorSummaryItemWithoutImage from "./BuilderEstimatorSummaryItemWithoutImage.vue";
  import type { OptionalUpgrade } from "@/types/OptionalUpgradeInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorQuoterSummaryItem',
  props: {
    title: {},
    value: {},
    price: {},
    imageUrl: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  

const __returned__ = { BuilderEstimatorQuoterSummaryItemWithImage, BuilderEstimatorSummaryItemWithoutImage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})